import { Injectable } from '@angular/core';

@Injectable()
export class ConstantService {
    API_ENDPOINT: String;
    constructor() {
        this.API_ENDPOINT = '/TECNIENLINEA/api/';
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/utils/constant.service.ts